export const selectIsUpdatingBooking = state => state.bookingReducer.updatingBooking;
export const selectIsCreatingBooking = state => state.bookingReducer.creatingBooking;
export const selectIsRequestingVacationOrResource = state => state.bookingReducer.makingRequest;